import { useState } from 'react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconMail, IconMailCheck, IconRefresh } from '@tabler/icons-react';
import { authApi } from '../api/auth';
import { useAuthStore } from '../auth/auth.store';

/**
 * Баннер для пользователей, у которых emailVerified=false.
 * Показывается над основным контентом в CabinetLayout. Кнопка «Отправить ещё раз»
 * шлёт POST /auth/resend-verification и аннулирует предыдущие неиспользованные
 * verify-токены.
 *
 * Если у пользователя email уже подтверждён — компонент возвращает null
 * (нет визуального вывода).
 */
export function EmailVerificationBanner() {
  const user = useAuthStore((s) => s.user);
  const [sending, setSending] = useState(false);
  const [sentAt, setSentAt] = useState<Date | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (!user || user.emailVerified) return null;

  const onResend = async () => {
    setSending(true);
    setError(null);
    try {
      await authApi.resendVerification();
      setSentAt(new Date());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось отправить');
    } finally {
      setSending(false);
    }
  };

  return (
    <Alert
      icon={<IconMail size={18} />}
      color="yellow"
      mb="md"
      title="Подтвердите email"
    >
      <Text size="sm" mb="xs">
        Мы отправили письмо на <strong>{user.email}</strong>. Пройдите по ссылке
        из письма, чтобы подтвердить адрес.
      </Text>
      <Group gap="xs">
        <Button
          size="xs"
          variant="white"
          leftSection={<IconRefresh size={14} />}
          onClick={onResend}
          loading={sending}
        >
          Отправить ещё раз
        </Button>
        {sentAt && (
          <Text size="xs" c="dimmed">
            <IconMailCheck size={12} style={{ verticalAlign: 'middle' }} /> отправлено в{' '}
            {sentAt.toLocaleTimeString('ru-RU')}
          </Text>
        )}
        {error && (
          <Text size="xs" c="red">
            {error}
          </Text>
        )}
      </Group>
    </Alert>
  );
}
